import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Types
import { Feature } from 'Shared/types/Organization.type';

// Hooks
import { useFeature } from 'Shared/utils/hooks';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import { Size, WpModal, WpModalBody, WpModalHeader } from 'Wpds/components/modal';
import GoalDetailPage from 'Dashboard/components/GoalDetailsPage/GoalDetailsPage';
import GoalDetailPageV3 from '../GoalDetailPageV3/GoalDetailPageV3';

type Props = {
  previousLocationPath?: string;
  size?: Size;
};

const GoalDetailsModal = ({ previousLocationPath, size = 'full' }: Props) => {
  const history = useHistory();
  const { isFreePlan } = useFeature(Feature.goals);
  const { featureFlagGoalsVersion3: showNewGoals } = useFlags();

  const hideBackdrop = size === 'full';
  const version = size === 'full' ? 'full-page' : 'slim';

  const handleBackClick = () => {
    // if loaded directly into goal details from a link, we don't have the redirect url,
    // so let's go back to the team page
    const redirectURL =
      previousLocationPath && history.location.pathname !== previousLocationPath
        ? previousLocationPath
        : PageUrls.GOALS_PAGE;
    history.push(redirectURL);
  };

  useEffect(() => {
    if (isFreePlan) {
      history.push(PageUrls.GOALS_PAGE);
    }
  }, []);

  const GoalPage = showNewGoals ? (
    <GoalDetailPageV3 handleCloseClick={handleBackClick} />
  ) : (
    <GoalDetailPage redirectTo={previousLocationPath} version={version} handleBackClick={handleBackClick} />
  );

  return (
    <WpModal isOpen size={size} hideBackdrop={hideBackdrop} onToggle={handleBackClick} dismissOnBackdrop={false}>
      {version === 'slim' ? (
        <>
          <WpModalHeader />
          <WpModalBody>{GoalPage}</WpModalBody>
        </>
      ) : (
        <>{GoalPage}</>
      )}
    </WpModal>
  );
};

export default GoalDetailsModal;
